(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maleaa-app-language"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('maleaa-app-language');
  if (!config) return;
  const replaceText = (element, source, value) => {
    for (const node of element.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === source) node.textContent = value;
      else if (node.nodeType === Node.ELEMENT_NODE) replaceText(node, source, value);
    }
  };
  const localize = () => {
    document.querySelectorAll('[data-essential-upsell-element="header"] [data-essential-upsell-element="title"]').forEach(element => replaceText(element, 'You may also like', config.dataset.related));
    document.querySelectorAll('[data-essential-upsell-element="add-to-cart-button"]').forEach(element => replaceText(element, 'Add', config.dataset.add));
    document.querySelectorAll('.jdgm-sort-dropdown-label').forEach(element => {
      if (element.textContent === 'Sort by') element.textContent = config.dataset.sort;
    });
    document.querySelectorAll('input.hdt-country_filter[placeholder="Search"]').forEach(element => element.setAttribute('placeholder', config.dataset.search));
  };
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; localize(); });
  });
  localize();
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["maleaa-localization"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('maleaa-localization');
  if (!config) return;
  config.dataset.state = 'ready';
  const preferenceKey = 'maleaa-localization-manual';
  const visitKey = 'maleaa-localization-checked';
  const form = document.getElementById('maleaa-auto-localization');
  let manual = false;
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch (_) { return 'unavailable'; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); return true; } catch (_) { return false; } };
  const remember = event => {
    const target = event.target;
    const selectedForm = target instanceof Element ? target.closest('form[action*="/localization"]') : null;
    if (!selectedForm || selectedForm === form) return;
    if (event.type === 'click' && !target.closest('[name="language_code"], [name="country_code"], [data-value]')) return;
    manual = true;
    write('localStorage', preferenceKey, '1');
  };
  document.addEventListener('submit', remember, true);
  document.addEventListener('change', remember, true);
  document.addEventListener('click', remember, true);
  if (config.dataset.language !== 'hr' || read('localStorage', preferenceKey) || read('sessionStorage', visitKey)) { config.dataset.state = 'preference-preserved'; return; }
  const params = new URLSearchParams(window.location.search);
  if (params.has('locale') || params.has('country') || params.has('language') || params.has('shopify_editor')) return;
  if (!write('sessionStorage', visitKey, '1')) return;
  const root = config.dataset.root.replace(/\/?$/, '/');
  config.dataset.state = 'detecting';
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 4000);
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', { credentials: 'same-origin', signal: controller.signal })
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      if (!data || manual || read('localStorage', preferenceKey)) return;
      const country = data.detected_values?.country?.handle;
      config.dataset.detectedCountry = country || '';
      config.dataset.state = 'checked';
      const language = { DE: 'de', SI: 'sl' }[country];
      if (!language || !config.dataset.languages.split(',').includes(language) || !config.dataset.countries.split(',').includes(country)) return;
      form.elements.namedItem('country_code').value = country;
      form.elements.namedItem('language_code').value = language;
      const returnTo = form.elements.namedItem('return_to');
      if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
      config.dataset.state = 'redirecting';
      form.submit();
    })
    .catch(() => { config.dataset.state = 'unavailable'; })
    .finally(() => window.clearTimeout(timeout));
})();
  } catch(e) { console.error(e); }
})();

})();
